<template>
	<Modal v-model="showModal" hasCloseIcon hasDivider :closeOnMask="false">
		<div slot="header">编辑公式 - {{templateItem.title}}</div>
		<Row v-width="720" class="margin-top" type="flex" :space-x="20">
			<Cell class="label">{{templateItem.sources == 0?'科目':'项目名称'}}</Cell>
			<Cell>
				<DropdownCustom ref="dropdown" :toggleIcon="false" trigger="manual">
					<input v-width="150" type="text" v-model="kmFiler" @focus="$refs.dropdown.show()">
					<div style="min-width: 150px;" slot="content" class="voucher-select">
						<ul>
							<li v-for="v in voucherFilterSelect" :key="v.id" @click="doSelect(v)">
								{{v.subjectFullName}}
							</li>
						</ul>
					</div>
				</DropdownCustom>
			</Cell>
			<Cell class="label">运算符号</Cell>
			<Cell><Select v-model="form.calculation" dict="operation" placeholder="运算符号" v-width="100" :deletable="false"/></Cell>
			<template v-if="templateItem.sources == 0">
				<Cell class="label">取数规则</Cell>
				<Cell><Select v-model="form.accessRules" v-width="120" placeholder="取数规则" :dict="'accessRules'+type" :deletable="false"/></Cell>
			</template>
			<Cell>
				<Button color="primary" @click="addItem">添加</Button>
			</Cell>
		</Row>
		<Table class="margin-top" :datas="formulas" border>
			<TableItem :title="templateItem.sources == 0?'科目':'项目名称'">
				<template slot-scope="{data}">
					{{voucherSelectMap[data.fromTag].name}}
				</template>
			</TableItem>
			<TableItem title="运算符号" prop="calculation"/>
			<TableItem v-if="templateItem.sources == 0" title="取数规则" prop="accessRules" :dict="'accessRules'+type"/>
			<TableItem :width="100">
				<div class="actions" slot-scope="{data,index}">
					<span @click="removeItem(index)">删除</span>
				</div>
			</TableItem>
		</Table>
		<div slot="footer">
			<button class="h-btn" :loading="loading" @click="showModal=false">取消</button>
			<Button color="primary" :loading="loading" @click="save">保存</Button>
		</div>
	</Modal>
</template>

<script>
/**
 * 该组件用于编辑模板数据项的公式。
 * 包含科目/项目名称选择、运算符号选择、取数规则设置、公式添加与删除以及保存等功能。
 */
	export default {
		name: "TemplateItemFormulaModal",
		props: {
			templateItems: Array,
		},
		data() {
			return {
				showModal: false,
				loading: false,
				type: '0',
				kmFiler: '',
				voucherSelect: [],
				templateItem: {},
				form: {
					fromTag: null,
					calculation: '+',
					accessRules: '0',
				},
				formulas: []
			}
		},
		watch: {
			showModal(val) {
				if (!val) {
					this.kmFiler = "";
					this.$set(this.form, 'fromTag', null);
				}
			}
		},
		computed: {
						/**
			 * 计算属性，将 voucherSelect 数组转换为以科目/项目 ID 为键的映射对象
			 * @returns {Object} 一个映射对象，键为科目/项目的 ID，值为对应的科目/项目对象
			 */
			voucherSelectMap() {
				// 初始化一个空对象，用于存储映射关系
				let map = {};
				// 遍历 voucherSelect 数组
				this.voucherSelect.forEach(value => {
					// 以每个元素的 id 作为键，元素本身作为值，存储到 map 对象中
					map[value.id] = value;
				});
				// 返回生成的映射对象
				return map;
			},

						/**
			 * 计算属性，根据搜索关键词过滤凭证选择列表
			 * 若存在搜索关键词，则返回包含该关键词的凭证选项；若不存在，则返回全部凭证选项
			 * @returns {Array} 过滤后的凭证选择列表
			 */
			voucherFilterSelect() {
				// 检查是否存在搜索关键词
				if (this.kmFiler) {
					// 若存在搜索关键词，使用 filter 方法对 voucherSelect 数组进行过滤
					return this.voucherSelect.filter(value => {
						// 只要凭证选项的编码、名称或助记码中包含搜索关键词，就保留该元素
						return value.code.indexOf(this.kmFiler) !== -1 || value.name.indexOf(this.kmFiler) !== -1 || value.mnemonicCode.indexOf(this.kmFiler) !== -1;
					});
				}
				// 若不存在搜索关键词，直接返回全部凭证选项
				return this.voucherSelect;
			}

		},
		methods: {
			doSelect(v) {
				this.$set(this.form, 'fromTag', v.id);
				this.kmFiler = v.name;
				this.$refs.dropdown.hide();
			},
			toggle(templateItem, type) {
				this.templateItem = templateItem;
				this.type = type;
				this.formulas = Array.from(templateItem.formulas);
				this.showModal = !this.showModal;
				if (templateItem.sources === 0 && this.showModal) {
					this.loadVoucherSelect();
				} else {
					this.voucherSelect = this.templateItems.map(val => {
						return {
							id: val.id,
							name: val.title,
							subjectFullName: `(${val.lineNum})` + val.title,
							mnemonicCode: val.title,
							code: val.title
						};
					});
				}
			},
			save() {
				this.loading = false;
				Api.report.template.items.formula({
					formulas: this.formulas,
					templateItemsId: this.templateItem.id
				}).then(() => {
					this.showModal = false;
					this.$emit('success');
				}).finally(() => {
					this.loading = false;
				});
			},
			addItem() {
				if (this.form.fromTag) {
					if (this.formulas.find(value => value.fromTag === this.form.fromTag && value.calculation === this.form.calculation && value.accessRules === this.form.accessRules)) {
						this.$Message("已存在相同运算公式！");
						return
					}
					this.formulas.push(Object.assign({
						templateId: this.templateItem.templateId,
						templateItemsId: this.templateItem.id
					}, this.form));
					this.$set(this.form, 'fromTag', null);
					this.kmFiler = "";
				}
			},
			removeItem(idx) {
				this.formulas.splice(idx, 1);
			},
						/**
			 * 加载所有凭证选择数据
			 * 优先从 localStorage 中获取缓存的凭证选择数据，若存在则先使用缓存数据，
			 * 同时发起 API 请求获取最新的凭证选择数据并更新 localStorage 中的缓存
			 */
			loadVoucherSelect() {
				// 从 localStorage 中获取名为 'voucherSelectAll' 的凭证选择数据
				let tmp = localStorage.getItem('voucherSelectAll');
				// 若 localStorage 中存在凭证选择数据
				if (tmp) {
					// 将获取到的 JSON 字符串解析为 JavaScript 对象，并赋值给组件的 voucherSelect 属性
					this.voucherSelect = JSON.parse(tmp);
				}
				// 调用 API 发起请求，获取所有的凭证选择数据
				Api.setting.subject.voucherSelect({showAll: true}).then(({data}) => {
					// 将 API 返回的最新凭证选择数据赋值给组件的 voucherSelect 属性
					this.voucherSelect = data;
					// 将最新的凭证选择数据以 JSON 字符串形式存储到 localStorage 中，更新缓存
					localStorage.setItem("voucherSelectAll", JSON.stringify(data));
				});
			}

		},
	}
</script>

<style scoped lang="less">
	.voucher-select {
		max-height: 200px;
		overflow-y: auto;

		li {
			padding: 5px;
			cursor: pointer;

			&:hover {
				background-color: #dff7df;
			}
		}
	}
</style>